var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-comment"},[_c('div',{staticClass:"comment-wrp"},[_c('input',{attrs:{"type":"text","placeholder":"Cevabınızı buraya yazınız..."}}),_c('span',{staticClass:"comment-ico"},[_c('svg-icon',{attrs:{"type":"icon-send"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }